/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuoteResponseDto } from '../../models/sales-quote-response-dto';

export interface QuotesControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Optional Project Manager id filter. When set, only quotes whose denormalised PM matches are returned. Used by the FE to scope the list to the logged Project Manager.
 */
  projectManagerId?: string;
}

export function quotesControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: QuotesControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuoteResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, quotesControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesQuoteResponseDto>>;
    })
  );
}

quotesControllerFindAllByTenant.PATH = '/o2-sales/quotes/{tenant}';
